var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStrategyGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Strategy-Split--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Strategy Split Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24a1.25 1.25 0 0 0 1.25 -1.25v-0.42A10.31 10.31 0 0 1 19 13.08a0.21 0.21 0 0 1 0.2 0 0.24 0.24 0 0 1 0.15 0.13l0.25 0.61a1 1 0 0 0 0.79 0.61 1 1 0 0 0 0.93 -0.39l2.52 -3.35a1 1 0 0 0 0.12 -1 1 1 0 0 0 -0.78 -0.61L19 8.51a1 1 0 0 0 -1.06 1.37l0.23 0.55a0.25 0.25 0 0 1 -0.13 0.32 12.92 12.92 0 0 0 -4.34 3.39 0.23 0.23 0 0 1 -0.27 0.07 0.25 0.25 0 0 1 -0.17 -0.23V6.21A0.25 0.25 0 0 1 13.5 6h0.81a1 1 0 0 0 0.9 -0.52 1.06 1.06 0 0 0 0 -1.05L12.9 0.47a1.09 1.09 0 0 0 -1.8 0L8.79 4.39a1.06 1.06 0 0 0 0 1.05 1 1 0 0 0 0.9 0.52h0.81a0.25 0.25 0 0 1 0.25 0.25V14a0.26 0.26 0 0 1 -0.17 0.23 0.23 0.23 0 0 1 -0.27 -0.07A12.92 12.92 0 0 0 6 10.75a0.25 0.25 0 0 1 -0.13 -0.32l0.23 -0.55a1 1 0 0 0 -0.13 -1A1 1 0 0 0 5 8.51l-4.14 0.58a1 1 0 0 0 -0.66 1.6L2.72 14a1 1 0 0 0 1.72 -0.22l0.25 -0.61a0.24 0.24 0 0 1 0.15 -0.13 0.21 0.21 0 0 1 0.2 0 10.31 10.31 0 0 1 5.71 9.25v0.42A1.25 1.25 0 0 0 12 24Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStrategyGames);
export default ForwardRef;